export default {
  state: {
    models: [
      {
        type: 'hoodies', // тип изделия
        model: 'tolstovka-xudi-kenguru-premium', // УНИКАЛЬНОЕ, модель
        title: 'Толстовка-худи "Кенгуру" Премиум', // заголовок
        description: `<p>Толстовка худи-кенгуру Премиум качества, с манжетами на поясе и рукавах. Мягкая теплая ткань футер 3-нитка с начесом с внутренней стороны толстовки. Манжеты, горловина и низ изделия выполнены из мягкой рибаны. Представлен в 21 наиболее популярном цвете.</p>
        <p><span style="color: #ff0000;"><strong>Внимание – часть моделей Худи Премиум идут с белым круглым шнурком!</strong></span></p>
        <p><strong>Плотность</strong>: 330 г/м2;<br>
        <strong>Состав</strong>: 80% ХБ, 20% ПЭ;<br>
        <strong>Тип полотна:</strong> Футер трехнитка с начесом<br>
        <strong>Размеры:</strong> XS, S, M, L, XL, XXL, 3XL, 4XL, 5XL, 6XL, 7XL, 8XL, 9XL;<br>
        <strong>Рукав:</strong> втачной;</p>
        <p><strong>Шнурок:</strong> белый;<br>
        <strong>Силуэт:</strong> прямой;<br>
        <strong>Крашение</strong>: активное, суперстойкое;<br>
        <strong>Марка:</strong> PR-Tex Premium.</p>`,
        gender: 'male', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'burgundy', 'chocolate', 'dark-green', 'fuchsia', 'mustard', 'green', 'red',
          'melange', 'orange', 'sand', 'blue', 'plum', 'dark-blue', 'white', 'yellow',
          'cherry', 'anthracite', 'lettuce', 'indigo'], // доступные цвета
        defaultColor: 'lettuce',
        image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-salat.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-chernaya.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-chernaya-100x100.jpg',
          },
          {
            color: 'burgundy',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-bordo.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-bordo-100x100.jpg',
          },
          {
            color: 'chocolate',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/02/chocolate.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/02/chocolate-100x100.jpg',
          },
          {
            color: 'dark-green',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-temno-zeleniy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-temno-zeleniy-100x100.jpg',
          },
          {
            color: 'fuchsia',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-ro%D1%8Foviy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-ro%D1%8Foviy-100x100.jpg',
          },
          {
            color: 'mustard',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/02/gorchcitsa.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/02/gorchcitsa-100x100.jpg',
          },
          {
            color: 'green',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-zeleniy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-zeleniy-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-krasniy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-krasniy-100x100.jpg',
          },
          {
            color: 'melange',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-melange.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-melange-100x100.jpg',
          },
          {
            color: 'orange',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-orange.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-orange-100x100.jpg',
          },
          {
            color: 'sand',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/02/pesok.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/02/pesok-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-sinyaya.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-sinyaya-100x100.jpg',
          },
          {
            color: 'plum',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-sliva.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-sliva-100x100.jpg',
          },
          {
            color: 'dark-blue',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-temno-sinyaya.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-temno-sinyaya-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-beliy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-beliy-100x100.jpg',
          },
          {
            color: 'yellow',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-zheltiy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-zheltiy-100x100.jpg',
          },
          {
            color: 'cherry',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-vishnya.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-vishnya-100x100.jpg',
          },
          {
            color: 'anthracite',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-antracit.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-antracit-100x100.jpg',
          },
          {
            color: 'lettuce',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-salat.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-salat-100x100.jpg',
          },
          {
            color: 'indigo',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-indigo.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/hoodie-premium-indigo-100x100.jpg',
          },
        ],
        sizes: ['xs', 's', 'm', 'l', 'xl', '2xl', '3xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          {from: 1, to: 2, price: 1500 },
          {from: 3, to: 5, price: 1350 },
          {from: 6, to: 10, price: 1250 },
          {from: 11, to: 20, price: 1200 },
          {from: 21, to: 30, price: 1150 },
          {from: 31, to: 50, price: 990 },
          {from: 51, to: 100, price: 950 },
          {from: 101, to: 250, price: 910 },
          {from: 251, to: 500, price: 890 },
          {from: 501, to: 1000, price: 850 },
          {from: 1001, to: 3000, price: 830 },
          {from: 3001, to: 5000, price: 810 },
          {from: 5001, to: 99999, price: 790 },
        ]
      },
      {
        type: 'hoodies', // тип изделия
        model: 'hoodi-standart', // УНИКАЛЬНОЕ, модель
        title: 'Толстовка-худи "Кенгуру"', // заголовок
        description: `<p>Стильная толстовка-кенгуру, с манжетами на поясе и рукавах. Мягкий начес с внутренней стороны изделия. Манжеты, горловина и низ изделия выполнены из мягкой рибаны. Представлен в 8 цветах – вы точно подберете тон под ваш фирменный стиль.</p>
        <p><strong>Плотность</strong>: 260 г/м2;<br>
        <strong>Состав</strong>: 100% хлопок высшего качества;<br>
        <strong>Тип полотна:</strong> Футер двухнитка с начесом<br>
        <strong>Размеры:</strong> XS, S, M, L, XL, XXL, 3XL;<br>
        <strong>Рукав:</strong> втачной;<br>
        <strong>Силуэт:</strong> прямой;<br>
        <strong>Крашение</strong>: активное, суперстойкое;<br>
        <strong>Марка:</strong> PR-Tex&nbsp;Classic.</p>`,
        gender: 'male', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'cyan', 'green', 'red', 'melange', 'orange', 'sand', 'gray',
          'blue', 'white'], // доступные цвета
        defaultColor: 'green',
        image: 'https://pr-tex.ru/wp-content/uploads/zeleniy-3.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/black-8.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/black-8-100x100.jpg',
          },
          {
            color: 'cyan',
            image: 'https://pr-tex.ru/wp-content/uploads/goluboy-4.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/goluboy-4-100x100.jpg',
          },
          {
            color: 'green',
            image: 'https://pr-tex.ru/wp-content/uploads/zeleniy-3.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/zeleniy-3-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/krasniy-4.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/krasniy-4-100x100.jpg',
          },
          {
            color: 'melange',
            image: 'https://pr-tex.ru/wp-content/uploads/melange-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/melange-2-100x100.jpg',
          },
          {
            color: 'orange',
            image: 'https://pr-tex.ru/wp-content/uploads/orange-3.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/orange-3-100x100.jpg',
          },
          {
            color: 'sand',
            image: 'https://pr-tex.ru/wp-content/uploads/pesok-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/pesok-2-100x100.jpg',
          },
          {
            color: 'gray',
            image: 'https://pr-tex.ru/wp-content/uploads/seriy-melange-1.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/seriy-melange-1-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/siniy-6.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/siniy-6-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/beliy-4.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/beliy-4-100x100.jpg',
          },
        ],
        sizes: ['xs', 's', 'm', 'l', 'xl', '2xl', '3xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          {from: 0, to: 5, price: 1200 },
          {from: 6, to: 10, price: 1000 },
          {from: 11, to: 20, price: 900 },
          {from: 21, to: 50, price: 800 },
          {from: 51, to: 100, price: 750 },
          {from: 101, to: 250, price: 700 },
          {from: 251, to: 500, price: 650 },
          {from: 501, to: 1000, price: 600 },
          {from: 1001, to: 3000, price: 580 },
        ]
      },
      {
        type: 'hoodies', // тип изделия
        model: 'kenguru-detskoe', // УНИКАЛЬНОЕ, модель
        title: 'Толстовка детская на молнии', // заголовок
        description: `<p>Детская модель толстовки на молнии прямого силуэта с манжетами на поясе и рукавах. Петлевая изнанка с внутренней стороны изделия. Манжеты, горловина и низ изделия выполнены из мягкой рибаны. Складская программа представлена в 7 цветах: меланж и черный. 7 и более цветов для пошива под заказа – вы точно подберете тон под ваш фирменный стиль.<br>
        <strong>Плотность:</strong> 240 г/м2;<br>
        <strong>Состав:</strong> 92% Хлопок, 8% Лайкра;<br>
        <strong>Тип полотна:</strong> Футер двухнитка с петлей пр-во Турции<br>
        <strong>Размеры:</strong>&nbsp;28 – 40;<br>
        <strong>Крой:</strong> прямой<br>
        <strong>Рукав:</strong> втачной;<br>
        <strong>Силуэт:</strong> прямой;<br>
        <strong>Крашение:</strong> активное, суперстойкое;<br>
        <strong>Марка:</strong> PR-Tex&nbsp;Classic.</p>`,
        gender: 'children', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'fuchsia', 'azure', 'melange', 'menthol', 'orange', 'sand', 'gray',
          'blue', 'lilac', 'white', 'yellow'], // доступные цвета
        defaultColor: 'melange',
        image: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_06.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_12.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_12-100x100.jpg',
          },
          {
            color: 'fuchsia',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02-100x100.jpg',
          },
          {
            color: 'azure',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02-100x100.jpg',
          },
          {
            color: 'melange',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_06.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_06-100x100.jpg',
          },
          {
            color: 'menthol',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02-100x100.jpg',
          },
          {
            color: 'orange',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02-100x100.jpg',
          },
          {
            color: 'sand',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02-100x100.jpg',
          },
          {
            color: 'gray',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02-100x100.jpg',
          },
          {
            color: 'lilac',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02-100x100.jpg',
          },
          {
            color: 'yellow',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/02/kenguru-molniya_02-100x100.jpg',
          },
        ],
        sizes: ['28', '32', '36', '40', '44'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          {from: 0, to: 10, price: 1100 },
          {from: 11, to: 20, price: 900 },
          {from: 21, to: 30, price: 800 },
          {from: 31, to: 50, price: 720 },
          {from: 51, to: 100, price: 680 },
          {from: 101, to: 250, price: 650 },
          {from: 251, to: 500, price: 620 },
          {from: 501, to: 1000, price: 610 },
          {from: 1001, to: 3000, price: 599 },
          {from: 3001, to: 100000, price: 590 },
        ]
      },
      {
        type: 'hoodies', // тип изделия
        model: 'tolstovki-kapushon-molniya', // УНИКАЛЬНОЕ, модель
        title: 'Толстовка с капюшоном на молнии', // заголовок
        description: `<p>Толстовка с капюшоном&nbsp;на молнии прямого силуэта. Манжеты внизу и на рукавах, шнурки для регулировки.</p>
        <p><strong>Стиль:</strong> Унисекс. Толстовка подходит для мужчин и для женщин.</p>
        <p><strong>Состав:&nbsp;</strong>100% хлопок, футер 3-нитка с начесом 330 г/м2.</p>
        <p><strong>Плотность:&nbsp;</strong>330гр/м2</p>
        <p><strong>Размеры: </strong>S, M, L, XXL, 3XL</p>`,
        gender: 'male', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'khaki', 'blue', 'dark-blue', 'white'], // доступные цвета
        defaultColor: 'white',
        image: 'https://pr-tex.ru/wp-content/uploads/2018/10/%D1%82%D0%BE%D0%BB%D1%81%D1%82%D0%BE%D0%B2%D0%BA%D0%B0-%D0%BD%D0%B0-%D0%BC%D0%BE%D0%BB%D0%BD%D0%B8%D0%B8_%D0%B1%D0%B5%D0%BB%D0%B0%D1%8F.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/%D1%82%D0%BE%D0%BB%D1%81%D1%82%D0%BE%D0%B2%D0%BA%D0%B0-%D0%BD%D0%B0-%D0%BC%D0%BE%D0%BB%D0%BD%D0%B8%D0%B8_%D1%87%D0%B5%D1%80%D0%BD.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/%D1%82%D0%BE%D0%BB%D1%81%D1%82%D0%BE%D0%B2%D0%BA%D0%B0-%D0%BD%D0%B0-%D0%BC%D0%BE%D0%BB%D0%BD%D0%B8%D0%B8_%D1%87%D0%B5%D1%80%D0%BD-100x100.jpg',
          },
          {
            color: 'khaki',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/%D1%82%D0%BE%D0%BB%D1%81%D1%82%D0%BE%D0%B2%D0%BA%D0%B0-%D0%BD%D0%B0-%D0%BC%D0%BE%D0%BB%D0%BD%D0%B8%D0%B8_%D1%85%D0%B0%D0%BA%D0%B8.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/%D1%82%D0%BE%D0%BB%D1%81%D1%82%D0%BE%D0%B2%D0%BA%D0%B0-%D0%BD%D0%B0-%D0%BC%D0%BE%D0%BB%D0%BD%D0%B8%D0%B8_%D1%85%D0%B0%D0%BA%D0%B8-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/%D1%82%D0%BE%D0%BB%D1%81%D1%82%D0%BE%D0%B2%D0%BA%D0%B0-%D0%BD%D0%B0-%D0%BC%D0%BE%D0%BB%D0%BD%D0%B8%D0%B8_%D0%B2%D0%B0%D1%81%D0%B8%D0%BB%D0%B5%D0%BA.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/%D1%82%D0%BE%D0%BB%D1%81%D1%82%D0%BE%D0%B2%D0%BA%D0%B0-%D0%BD%D0%B0-%D0%BC%D0%BE%D0%BB%D0%BD%D0%B8%D0%B8_%D0%B2%D0%B0%D1%81%D0%B8%D0%BB%D0%B5%D0%BA-100x100.jpg',
          },
          {
            color: 'dark-blue',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/%D1%82%D0%BE%D0%BB%D1%81%D1%82%D0%BE%D0%B2%D0%BA%D0%B0-%D0%BD%D0%B0-%D0%BC%D0%BE%D0%BB%D0%BD%D0%B8%D0%B8_%D1%82%D0%B5%D0%BC%D0%BD%D0%BE-%D1%81%D0%B8%D0%BD%D1%8F%D1%8F.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/%D1%82%D0%BE%D0%BB%D1%81%D1%82%D0%BE%D0%B2%D0%BA%D0%B0-%D0%BD%D0%B0-%D0%BC%D0%BE%D0%BB%D0%BD%D0%B8%D0%B8_%D1%82%D0%B5%D0%BC%D0%BD%D0%BE-%D1%81%D0%B8%D0%BD%D1%8F%D1%8F-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/%D1%82%D0%BE%D0%BB%D1%81%D1%82%D0%BE%D0%B2%D0%BA%D0%B0-%D0%BD%D0%B0-%D0%BC%D0%BE%D0%BB%D0%BD%D0%B8%D0%B8_%D0%B1%D0%B5%D0%BB%D0%B0%D1%8F.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/%D1%82%D0%BE%D0%BB%D1%81%D1%82%D0%BE%D0%B2%D0%BA%D0%B0-%D0%BD%D0%B0-%D0%BC%D0%BE%D0%BB%D0%BD%D0%B8%D0%B8_%D0%B1%D0%B5%D0%BB%D0%B0%D1%8F-100x100.jpg',
          },
        ],
        sizes: ['s', 'm', 'l', '2xl', '3xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          {from: 0, to: 5, price: 1300 },
          {from: 6, to: 10, price: 1100 },
          {from: 11, to: 20, price: 850 },
          {from: 21, to: 50, price: 800 },
          {from: 51, to: 100, price: 750 },
          {from: 101, to: 250, price: 700 },
          {from: 251, to: 500, price: 650 },
          {from: 501, to: 1000, price: 620 },
          {from: 1001, to: 3000, price: 600 },
        ]
      },
    ]
  }
}